import { isTouch } from '../../helpers/detect-device';

export default () => {

	const header = document.querySelector('.js-header');
	if (!header) return;

	const burger = header.querySelector('.js-burger');
	const close = header.querySelector('.js-burger-close');
	const openSubmenuSel = '.js-open-submenu';
	const openSubmenusBtns = header.querySelectorAll(openSubmenuSel);
	const mobMenu = header.querySelector('.js-mob-menu');
	const submenuSel = '.js-submenu';
	const submenuData = 'data-submenu';
	const closeBtnSel = '.js-close-submenu';
	const btnActiveClass = 'active';
	const headerOpenedClass = 'opened-submenu';
	const hiddenClass = 'is-invisible';
	const headerMenuSel = '.js-header-menu';
	const submenuDarkenSel = '.js-submenu-darken';

	burger.addEventListener('click', () => {
		document.body.classList.add('no-scroll');
		mobMenu.classList.remove(hiddenClass);
	});

	close.addEventListener('click', () => {
		document.body.classList.remove('no-scroll');
		mobMenu.classList.add(hiddenClass);
		const submenu = header.querySelector(`${submenuSel}:not(.${hiddenClass})`);
		if (submenu) {
			submenu.classList.add(hiddenClass);
		}
	});

	if (openSubmenusBtns.length) {

		header.addEventListener('mousemove', e => {
			if (isTouch()) return;

			const target = e.target;

			if (target.closest(openSubmenuSel)) {

				const openBtn = target.closest(openSubmenuSel);
				const submenu = header.querySelector(`[${submenuData}="${openBtn.dataset.openSubmenu}"]`);
				const prevAnotherOpen = detectAnotherOpen(openBtn);

				openBtn.classList.add(btnActiveClass);

				if (prevAnotherOpen) { // keep open menu, change submenu
					changeOpenedSubmenu(openBtn, submenu);
				}

				else { // open submenu
					openSubmenu(openBtn, submenu);
				}

			}

			else if (target.closest(headerMenuSel)) return;

			else if (target.closest(submenuSel) && !target.closest(submenuDarkenSel)) return;

			else {
				openSubmenusBtns.forEach(openBtn => {
					const submenu = header.querySelector(`[${submenuData}="${openBtn.dataset.openSubmenu}"]`);
					closeSubmenu(openBtn, submenu);
				});
			}

		});

		header.querySelectorAll(`${headerMenuSel} a`).forEach(link => {
			if (link.matches(openSubmenuSel)) return;

			let prevActiveOpenBtn;

			link.addEventListener('mouseenter', () => {
				prevActiveOpenBtn = header.querySelector(`${openSubmenuSel}.${btnActiveClass}`);
				prevActiveOpenBtn.classList.remove(btnActiveClass);
			});

			link.addEventListener('mouseleave', () => {
				if (prevActiveOpenBtn) prevActiveOpenBtn.classList.add(btnActiveClass);
			});

		});

		openSubmenusBtns.forEach(openBtn => {

			const submenu = header.querySelector(`[${submenuData}="${openBtn.dataset.openSubmenu}"]`);
			const closeBtn = submenu.querySelector(closeBtnSel);

			openBtn.addEventListener('click', e => {
				e.stopImmediatePropagation();
				e.preventDefault();

				if (window.innerWidth > 999 && isTouch()) {

					const prevAnotherOpen = detectAnotherOpen(openBtn);
					const prevCurrentOpen = openBtn.matches(`.${btnActiveClass}`);

					if (prevAnotherOpen) { // keep open menu, change submenu
						changeOpenedSubmenu(openBtn, submenu);
					}

					else if (prevCurrentOpen) { // close submenu
						closeSubmenu(openBtn, submenu);
					}

					else { // open submenu
						openSubmenu(openBtn, submenu);
					}

				}

				else if (window.innerWidth <= 999) {

					submenu.classList.remove(hiddenClass);

				}

			});

			submenu.addEventListener('click', e => {
				if (!e.target.matches(submenuDarkenSel) || window.innerWidth < 1000) return;
				closeSubmenu(openBtn, submenu);
			});

			closeBtn.addEventListener('click', () => {
				submenu.classList.add(hiddenClass);
			});

		});

		function detectAnotherOpen(currentBtn) {
			let prevAnotherOpen;

			openSubmenusBtns.forEach(notActiveBtn => {
				if (notActiveBtn == currentBtn) return;
				if (notActiveBtn.matches(`.${btnActiveClass}`)) prevAnotherOpen = true;
				notActiveBtn.classList.remove(btnActiveClass);
			});

			return prevAnotherOpen;
		}

		function openSubmenu(openBtn, submenu) {
			openBtn.classList.add(btnActiveClass);
			document.body.classList.add('no-scroll');
			header.classList.add(headerOpenedClass);
			submenu.classList.remove(hiddenClass);
		}

		function closeSubmenu(openBtn, submenu) {
			openBtn.classList.remove(btnActiveClass);
			header.classList.remove(headerOpenedClass);
			submenu.classList.add(hiddenClass);
			document.body.classList.remove('no-scroll');
		}

		function changeOpenedSubmenu(openBtn, submenu) {
			openBtn.classList.add(btnActiveClass);
			header.querySelector(`${submenuSel}:not(.${hiddenClass})`).classList.add(hiddenClass);
			submenu.classList.remove(hiddenClass);
		}
	}

}

export function resetMegamenu() {

	const header = document.querySelector('.js-header');
	if (!header) return;

	const close = header.querySelector('.js-burger-close');
	const openSubmenusBtn = header.querySelector('.js-open-submenu.active');

	close.click();
	header.classList.remove('opened-submenu');
	if (openSubmenusBtn) openSubmenusBtn.classList.remove('active');
	document.body.classList.remove('no-scroll');

}